import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template'

export async function refreshToken (tokenSetInfo) {
  const urlEndpoint = '/api/connect-xero/:xeroTokenId/refresh-token'

  const url = fillString(urlEndpoint, {
    xeroTokenId: tokenSetInfo.appTokenId
  })

  const response = await callApi(url, null, {
    method: 'PUT'
  })
  console.log('response', response)
}
